const crops = {
    crops: {
        "1": "Pastèque",
        "2": "Courge d`été citrouille",
        "3": "Aubergine",
        "4": "Canne à sucre",
        "5": "Concombre en saumure",
        "6": "Pommes",
        "7": "Céleri",
        "8": "Abricots",
        "9": "Céleri vert d`automne",
        "10": "Ciboulette - 1 an",
        "11": "Ciboulette - 2 ans",
        "12": "Carottes lavées",
        "13": "Patate douce",
        "14": "Maïs (ensilage 67 % d`eau)",
        "15": "Pêche",
        "16": "Pomme de terre",
        "17": "Oignons frais",
        "18": "Aïl",
        "19": "Chou frisé (kale)",
        "20": "Fraises",
        "21": "Betterave",
        "22": "Brocoli",
        "23": "Choux de Bruxelles",
        "24": "Céleri en branche - automne",
        "25": "Betteraves sucrières",
        "26": "Carotte d`hiver",
        "27": "Tomates",
        "28": "Oignons d`hiver",
        "29": "Raisin (de table)",
        "30": "Laitue d`été",
        "31": "Persil",
        "32": "Laitue d`été à feuilles de chêne",
        "33": "Laitue à feuilles de chêne",
        "34": "Topinambour",
        "35": "Pruneaux",
        "36": "Cantaloup",
        "37": "Huile de palme",
        "38": "Laitue",
        "39": "Kiwi",
        "40": "Choux rouge",
        "41": "Poire",
        "42": "Banane",
        "43": "Endive scarole - été",
        "44": "Endive scarole - baby",
        "45": "Endive à feuilles frisées",
        "46": "Chou - conservation commune",
        "47": "Poireau d`été",
        "48": "Poireau automne hiver",
        "49": "Fraise à fruits perpétuels",
        "50": "Papaye",
        "51": "Épinards",
        "52": "Traitement des tomates",
        "53": "Courge",
        "54": "Chicorée",
        "55": "Choux",
        "56": "Aubergine",
        "57": "Choux de printemps",
        "58": "Chou savoyard",
        "59": "Chou vert savoyard",
        "60": "Haricot commun",
        "61": "Oranges",
        "62": "Échalote rouge",
        "63": "Melon",
        "64": "Tabac (flûte)",
        "65": "Tabac (burley)",
        "66": "Café",
        "67": "Orge (printemps)",
        "68": "Blé à 10 % de protéines",
        "69": "Blé à 12 % de protéines",
        "70": "Blé à 14 % de protéines",
        "71": "Maïs (céréales)",
        "72": "Tournesol",
        "73": "Riz",
        "74": "Sorgho (grain) ",
    },
};
export default crops;
